import { CE_MODAL_CLOSE } from "@js/actions/studio/modals.js";

export const CE_MODAL_INSERT_FORM_OPEN = "CE_MODAL_INSERT_FORM_OPEN";
export const ceModalInsertFormOpen = (format) => ({
  type: CE_MODAL_INSERT_FORM_OPEN,
  format: format,
});

export const ceModalInsertFormClose = () => ({
  type: CE_MODAL_CLOSE,
});
